module.exports = __webpack_public_path__ + "img/four-1.143a0098.png";